module.exports = __webpack_public_path__ + "static/media/vantaggi 2.3e4bc62e.png";